import { Tuple } from "@suse-o11y/tuple";
import React from "react";
import { useLocation } from "react-router-dom";

import { CONTEXT_PROVIDER_NAME, SmartHistoryContext } from "./context";
import { SmartHistoryQueue } from "./SmartHistoryQueue";
import { schema } from "./schema";

interface SmartHistoryBoundaryProps {
	children: React.ReactNode;
}

/**
 * Provides a SmartHistoryQueue instance and setter ofr it.
 *
 * The queue is kept in-memory only so that each browser tab
 * maintains its own independent navigation history.
 * Enqueues the current location on every location change.
 */

export const SmartHistoryBoundary: React.FC<SmartHistoryBoundaryProps> = ({ children }) => {
	const location = useLocation();

	const [smartHistoryQueue, setSmartHistoryQueue] = React.useState(() =>
		SmartHistoryQueue.init(schema, { maxSize: 100 }),
	);

	const context = React.useMemo(() => Tuple(smartHistoryQueue, setSmartHistoryQueue), [smartHistoryQueue]);

	// write to the queue on location change
	React.useEffect(() => {
		setSmartHistoryQueue((current) => current.enqueue(location));
	}, [location]);

	return <SmartHistoryContext.Provider value={context}>{children}</SmartHistoryContext.Provider>;
};

SmartHistoryBoundary.displayName = CONTEXT_PROVIDER_NAME;
